import axios from 'axios'
import { debounce } from 'lodash'
import cardValidator from 'card-validator'
import rebuildSelect from ':/functions/rebuild-select'

const compareAddresses = (address1, address2) => {

  Object.keys(address1).map(function (key) {
    if (address1[key] == null) {
      address1[key] = '';
    }
  });

  Object.keys(address2).map(function (key,) {
    if (address2[key] == null) {
      address2[key] = '';
    }
  });

  const address1String = address1.name + address1.address_1 + address1.address_2 + address1.address_3 + address1.city + address1.country + address1.state  + address1.postcode + address1.phone_number
  const address2String = address2.name + address2.address_1 + address2.address_2 + address2.address_3 + address2.city + address2.country + address2.state  + address2.postcode + address2.phone_number

  return address1String === address2String;
}

export default () => ({
  initialized: false,
  addresses: {
    billing: {
      name: '',
      address_1: '',
      address_2: '',
      address_3: '',
      city: '',
      country: '',
      state: '',
      city: '',
      postcode: '',
      phone_number: ''
    },
    shipping: {
      toBilling: false,
      name: '',
      address_1: '',
      address_2: '',
      address_3: '',
      city: '',
      country: '',
      state: '',
      city: '',
      postcode: '',
      phone_number: ''
    }
  },
  billingAddressSave: false,
  shippingAddressSave: false,
  billingAddresses: {},
  shippingAddresses: {},
  billingAddressSelected : '',
  shippingAddressSelected : '',
  billingStates: {},
  shippingStates: {},
  couponCode: '',
  shippingMethod: '',
  shippingAccounts: {},
  shippingAccountSelected: '',
  shippingAccountSave: false,
  shippingAccountData: {
    vendor: '',
    method: '',
    number: '',
    instructions: '',
  },
  shippingVendorMethods: {},
  paymentMethod: 'credit-card',
  cardToken: '',
  cardActive: false,
  cardData: {
    cardNumber: '',
    month: '',
    year: '',
    cardCode: '',
    postcode: ''
  },
  purchaseOrderNumber: '',
  errors : {},
  canSubmit: false,
  submitting: false,
  refreshing: false,
  init() {

    this.initialized = true;

    this.$watch('addresses.billing.country', debounce(() => {
      this.updateStates('billing');
    }, 100))

    this.$watch('addresses.shipping.country', debounce(() => {
      this.updateStates('shipping');
    }, 100))

    this.$watch('shippingMethod', debounce(() => {
      this.updateShippingMethod()
    }, 100))

    this.$watch('addresses', debounce(() => {
      this.updateDestination()
    }, 100))

    this.$watch('shippingAccountData.vendor', () => {
      this.refreshing = true;
    })

    this.$watch('refreshing', debounce(to => {
      if(to) {
        this.refreshDynamics();
      }
    }, 200))

    this.$watch('billingAddressSelected', (to, from) => {
      if(to !== from && to !== '') {
        this.addresses.billing.name = this.billingAddresses[to].name
        this.addresses.billing.country = this.billingAddresses[to].country
        this.addresses.billing.address_1 = this.billingAddresses[to].address_1
        this.addresses.billing.address_2 = this.billingAddresses[to].address_2
        this.addresses.billing.address_3 = this.billingAddresses[to].address_3
        this.addresses.billing.city = this.billingAddresses[to].city
        this.addresses.billing.state = this.billingAddresses[to].state
        this.addresses.billing.postcode = this.billingAddresses[to].postcode
        this.addresses.billing.phone_number = this.billingAddresses[to].phone_number
        this.billingAddressSave = false
      }
    })

    this.$watch('addresses.billing', to => {
      let match = '';

      Object.keys(this.billingAddresses).forEach(key => {

        if(compareAddresses({
          name: this.billingAddresses[key].name,
          country: this.billingAddresses[key].country,
          address_1: this.billingAddresses[key].address_1,
          address_2: this.billingAddresses[key].address_2,
          address_3: this.billingAddresses[key].address_3,
          city: this.billingAddresses[key].city,
          state: this.billingAddresses[key].state,
          postcode: this.billingAddresses[key].postcode,
          phone_number: this.billingAddresses[key].phone_number
        }, to)
        ) {
          match = key;
        }
      })

      this.billingAddressSelected = match
    })

    this.$watch('shippingAddressSelected', (to, from) => {
      if(to !== from && to !== '') {
        this.addresses.shipping.name = this.shippingAddresses[to].name
        this.addresses.shipping.country = this.shippingAddresses[to].country
        this.addresses.shipping.address_1 = this.shippingAddresses[to].address_1
        this.addresses.shipping.address_2 = this.shippingAddresses[to].address_2
        this.addresses.shipping.address_3 = this.shippingAddresses[to].address_3
        this.addresses.shipping.city = this.shippingAddresses[to].city
        this.addresses.shipping.state = this.shippingAddresses[to].state
        this.addresses.shipping.postcode = this.shippingAddresses[to].postcode
        this.addresses.shipping.phone_number = this.shippingAddresses[to].phone_number
        this.shippingAddressSave = false
      }
    })

    this.$watch('addresses.shipping', to => {
      let match = '';

      Object.keys(this.shippingAddresses).forEach(key => {
        if(compareAddresses({
          name: this.shippingAddresses[key].name,
          country: this.shippingAddresses[key].country,
          address_1: this.shippingAddresses[key].address_1,
          address_2: this.shippingAddresses[key].address_2,
          address_3: this.shippingAddresses[key].address_3,
          city: this.shippingAddresses[key].city,
          state: this.shippingAddresses[key].state,
          postcode: this.shippingAddresses[key].postcode,
          phone_number: this.shippingAddresses[key].phone_number
        }, to)
        ) {
          match = key;
        }

      })

      this.shippingAddressSelected = match
    })

    this.$watch('shippingAccountSelected', (to, from) => {
      if(to !== from && to !== '') {
        this.shippingAccountData.vendor = this.shippingAccounts[to].vendor
        this.shippingAccountData.method = this.shippingAccounts[to].method
        this.shippingAccountData.number = this.shippingAccounts[to].number
        this.shippingAccountSave = false
      }
    })

    this.$watch('shippingAccountData', to => {
      let match = '';
      Object.keys(this.shippingAccounts).forEach(key => {
        if(
          this.shippingAccounts[key].vendor === to.vendor &&
          this.shippingAccounts[key].method === to.method &&
          this.shippingAccounts[key].number == to.number
        ) {
          match = key;
        }
      })
      this.shippingAccountSelected = match
    })

    this.$watch('cardData', () => {
      this.cardToken = ''
      this.canSubmit = false
    })
    if(document.head.querySelector('meta[name="authnet-client-key"]')) {
      this.cardActive = true;
      if(document.head.querySelector('meta[name="authnet-environment"]').content === 'sandbox') {
        this.cardData = {
          cardNumber: '4111111111111111',
          month: '12',
          year: '2025',
          cardCode: '123',
          postcode: '12345'
        }
      }
    }
  },
  showButtons() {
    return !this.submitting
  },
  scrollToErrors() {
    const scrollTo = this.$refs['errors'].getBoundingClientRect().top;
    window.scrollTo({top: scrollTo, behavior: 'smooth'});
  },
  submit(event) {

    if(!this.canSubmit) {
      event.preventDefault();
    }
    this.submitting = true;

    this.validate();

    if(this.errorsValues().length) {
      this.scrollToErrors()
      this.submitting = false;
      return
    }

    if(this.paymentMethod == 'credit-card') {
      const secureData = {
        authData : {
          clientKey : document.head.querySelector('meta[name="authnet-client-key"]').content,
          apiLoginID : document.head.querySelector('meta[name="authnet-account-id"]').content
        },
        cardData : {
          ...this.cardData,
          cardNumber: this.cardData.cardNumber.replace(/\s/g, ''),
          zip: this.cardData.postcode
        }
      }

      Accept.dispatchData(secureData, response => {
        if(response.messages.resultCode == 'Ok' && response.opaqueData) {
          this.cardToken = `${response.opaqueData.dataDescriptor}:${response.opaqueData.dataValue}`

          this.$nextTick(() => {
            this.canSubmit = true;
            this.$refs['form'].submit();
          })

        } else {
          this.addError('credit_card_number', 'There was an issue processing the credit card number.');
          this.scrollToErrors()
          this.submitting = false;
        }
      });

    } else if(this.paymentMethod == 'purchase-order') {

      this.canSubmit = true;
      this.$refs['form'].submit();

    }
  },
  validate() {

    this.errors = {};

    if(this.addresses.billing.name == '' || this.addresses.billing.name == null) {
      this.addError('billing_name', 'Billing name is required.');
    }

    if(this.addresses.billing.address_1 == '' || this.addresses.billing.address_1 == null) {
      this.addError('billing_address_1', 'Billing address is required.');
    }

    if(this.addresses.billing.city == '' || this.addresses.billing.city == null) {
      this.addError('billing_city', 'Billing city is required.');
    }

    if(this.addresses.billing.country == '' || this.addresses.billing.country == null) {
      this.addError('billing_country', 'Billing country is required.');
    }

    if(this.addresses.billing.state == '' || this.addresses.billing.state == null) {
      this.addError('billing_state', 'Billing state is required.');
    }

    if(this.addresses.billing.postcode == '' || this.addresses.billing.postcode == null) {
      this.addError('billing_postcode', 'Billing postcode is required.');
    }

    if(!this.addresses.shipping.toBilling) {

      if(this.addresses.shipping.name == '' || this.addresses.shipping.name == null) {
        this.addError('shipping_name', 'Shipping name is required.');
      }

      if(this.addresses.shipping.address_1 == '' || this.addresses.shipping.address_1 == null) {
        this.addError('shipping_address_1', 'Shipping address is required.');
      }

      if(this.addresses.shipping.city == '' || this.addresses.shipping.city == null) {
        this.addError('shipping_city', 'Shipping city is required.');
      }

      if(this.addresses.shipping.country == '' || this.addresses.shipping.country == null) {
        this.addError('shipping_country', 'Shipping country is required.');
      }

      if(this.addresses.shipping.state == '' || this.addresses.shipping.state == null) {
        this.addError('shipping_state', 'Shipping state is required.');
      }

      if(this.addresses.shipping.postcode == '' || this.addresses.shipping.postcode == null) {
        this.addError('shipping_postcode', 'Shipping postcode is required.');
      }
    }

    if(this.shippingMethod == 'account') {
      if(this.shippingAccountData.vendor == '') {
        this.addError('shipping_method_account_vendor', 'Shipping account vendor is required.');
      }
      if(this.shippingAccountData.method == '') {
        this.addError('shipping_method_account_method', 'Shipping account method is required.');
      }
      if(this.shippingAccountData.number == '') {
        this.addError('shipping_method_account_number', 'Shipping account number is required.');
      }
    } else {
      if(this.shippingAccountData.vendor == '') {
        this.addError('shipping_method_account_vendor', 'Shipping account vendor is required.');
      }
      if(this.shippingAccountData.method == '') {
        this.addError('shipping_method_account_method', 'Shipping account method is required.');
      }
    }

    if(this.paymentMethod == 'purchase-order') {
      if(this.purchaseOrderNumber == '') {
        this.addError('purchase_order_number', 'Purchase order number is required.');
      }
    } else if(this.paymentMethod == 'credit-card') {


      if(this.cardData.cardNumber == '') {
        this.addError('credit_card_number', 'Credit card number is required.');
      } else {
        const numberValidation = cardValidator.number(this.cardData.cardNumber);
        if(!numberValidation.isValid) {
          this.addError('credit_card_number', 'Credit card number is invalid.');
        } else if(!['visa', 'american-express', 'mastercard', 'discover'].includes(numberValidation.card.type)) {
          this.addError('credit_card_number', 'Credit card type must be Visa, Mastercard, American Express, or Discover Card.');
        }
      }

      if(this.cardData.month == '' && this.cardData.year == '') {
        this.addError('credit_card_month', 'Credit card expires month is required.');
        this.addError('credit_card_year', 'Credit card expires year is required.');
      } else {
        const dateValidation = cardValidator.expirationDate(`${this.cardData.month}/${this.cardData.year}`);
        if(!dateValidation.isValid) {
          this.addError('credit_card_month', 'Credit card expires month is invalid.');
          this.addError('credit_card_year', 'Credit card expires year is invalid.');
        }
      }

      if(this.cardData.cardCode == '') {
        this.addError('credit_card_code', 'Credit card security code is required.');
      }

      if(this.cardData.postcode == '') {
        this.addError('credit_card_postcode', 'Credit card ZIP code is required.');
      }
    }
  },
  updateStates(type) {

    const select = this.$refs[type + '-state'];

    axios.get('/shop/orders/checkout/ajax/states-for-country', {
      params: {
        type: type,
        country: this.addresses[type].country
      }
    })
    .then(response => {

      if(response.data.success === false || response.data.states.length === 0) {
        if(type == 'shipping') {
          this.shippingStates = {}
        } else {
          this.billingStates = {}
        }

        this.refreshing = true;

        return
      }

      if(type == 'shipping') {
        this.shippingStates = response.data.states
      } else {
        this.billingStates = response.data.states
      }

      let value = ''

      if(type == 'shipping') {
        value = this.shippingStates.hasOwnProperty(this.addresses.shipping.state) ? this.addresses.shipping.state : ''
      } else {
        value = this.billingStates.hasOwnProperty(this.addresses.billing.state) ? this.addresses.billing.state : ''
      }

      rebuildSelect(select, response.data.states, response.data.label, value)

      if(type == 'shipping') {
        this.addresses.shipping.state = value;
      } else {
        this.addresses.billing.state = value;
      }

      this.refreshing = true;
    })
  },
  updateDestination() {

    axios.post('/shop/orders/checkout/ajax/update-destination', {
      country: this.addresses.shipping.toBilling ? this.addresses.billing.country : this.addresses.shipping.country,
      city: this.addresses.shipping.toBilling ? this.addresses.billing.city : this.addresses.shipping.city ,
      state: this.addresses.shipping.toBilling ? this.addresses.billing.state : this.addresses.shipping.state ,
      postcode: this.addresses.shipping.toBilling ? this.addresses.billing.postcode : this.addresses.shipping.postcode
    }).then(response => {
      this.refreshing = true;
    })
  },
  updateShippingMethod() {

    axios.post('/shop/orders/checkout/ajax/update-shipping-method', {
      method: this.shippingMethod,
    }).then(response => {
      this.refreshing = true;
    })

  },
  applyCoupon() {
    axios.post('/shop/orders/checkout/ajax/apply-coupon', {
      code: this.couponCode,
    }).then(response => {
      if(response.data.success === false) {
        response.data.errors.forEach(error => {
          this.addError('coupon_code', error);
        })
        this.scrollToErrors()
        return;
      } else {
        this.refreshing = true;
      }
    })

  },
  removeCoupon() {

    axios.post('/shop/orders/checkout/ajax/remove-coupon')
      .then(response => {
        this.couponCode = ''
        this.refreshing = true;
      })
  },
  refreshDynamics() {

    const totals = this.$refs['totals'];
    const paymentMethods = this.$refs['payment-methods'];
    const shippingMethods = this.$refs['shipping-methods'];
    const coupon = this.$refs['coupon'];

    axios.get('/shop/orders/checkout/ajax/refresh', {
      params: {
        shipping_vendor: this.shippingAccountData.vendor
      }
    }).then(response => {

      this.refreshing = false;

      totals.innerHTML = response.data.templates.totals
      paymentMethods.innerHTML = response.data.templates.paymentMethods
      shippingMethods.innerHTML = response.data.templates.shippingMethods
      coupon.innerHTML = response.data.templates.coupon
    })
  },
  selectShippingAccount(event) {
    if(event.target.value === '') {
      this.shippingAccountData.vendor = ''
      this.shippingAccountData.method = ''
      this.shippingAccountData.number = ''
    }
  },
  selectAddress(event, type) {
    if(event.target.value === '') {
      this.addresses[type].name = ''
      this.addresses[type].country = 'US'
      this.addresses[type].address_1 = ''
      this.addresses[type].address_2 = ''
      this.addresses[type].city = ''
      this.addresses[type].state = ''
      this.addresses[type].postcode = ''
      this.addresses[type].phone_number = ''
    }
  },
  errorsValues() {
    return Object.values(this.errors);
  },
  errorsKeys() {
    return Object.keys(this.errors);
  },
  addError(key, error) {
    this.errors[key] = error
  }
})
